// extracted by mini-css-extract-plugin
export var dateLabel = "_33-0";
export var dateLabelError = "_33-1";
export var fullWidth = "_33-2";
export var smaller = "_33-3";